import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    /** 用户名 */
    userName: string;

    /** 密码 */
    password: string;

    /** 邮箱 */
    email: string;

    /** 忘记密码弹窗，显示状态 */
    isModalForget: boolean = false;

    /** 忘记密码弹窗，返回结果 */
    sendForgetResult: string;

    /** 重设密码结果 */
    isSetSuccess: boolean = false;
    /** 发送邮件 */
    sendSuccessMaile: string;
    /** 重设密码参数 */
    ticket: string;
    type: string; 
    ticketinfo:{
        activated: boolean;  // 如果activate为true 就直接加入公司 flase就需要设置密码再加入公司
        companyId: string; 
        companyName: string; 
        domain: string; 
        email: string; 
        existed: boolean; // 如果exist为false 就直接联系管理员
        gUserId: string; 
        inviteName: string; 
    };
    loginEmail: string = "";
    passwordCompliance: boolean = false;
    newPasTipMessage: string = '';
    newPasTipView: boolean = false;
    passConfig: any;
    passConfigArr: {}[];
    passConcigArrView: boolean = false;
    confirmDirty: boolean = false;
}



// WEBPACK FOOTER //
// ./src/display/modules/Home/Login/Modules.State.ts